Number.prototype.formatMoney = function(c, d, t){
  var n = this,
  c = isNaN(c = Math.abs(c)) ? 2 : c,
  d = d == undefined ? "." : d,
  t = t == undefined ? "," : t,
  s = n < 0 ? "-" : "",
  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
  j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

export class FormatMoney {

  constuctor() {
    this.$moneyInputs = $('[money-input]');
  }

  _FormatValue($el) {
    let ammount = parseFloat($el.val().replace(/[^0-9.]/g, ''));
    let $input = $($el.attr('money-input'));
    $input.val( (isNaN(ammount)) ? 0 : ammount);
    console.log($input.val());
    $el.val( ammount.formatMoney(2, '.', ',') );
  }

  init() {
    this.constuctor();
    const self = this;

    this.$moneyInputs.each(function() {
      self._FormatValue($(this));
    });

    this.$moneyInputs.on('blur change', function() {
      self._FormatValue($(this));
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/formatMoney.js